export default "__VITE_ASSET__DwTXzjKY__"